import { render, staticRenderFns } from "./funkcije-zaposlenih.editor.vue?vue&type=template&id=922afbb6&scoped=true&"
import script from "./funkcije-zaposlenih.editor.vue?vue&type=script&lang=ts&"
export * from "./funkcije-zaposlenih.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922afbb6",
  null
  
)

export default component.exports